<template>
    <div>
        <div class="container" style="width:100%;">
            <!-- <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">计划结案</span></div> -->

            <el-form :model="form" inline  style="padding-left:8px;margin-top:-20px;">
                <el-row  type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="终端客户">
                        {{planItem.终端客户}}
                    </el-form-item>
                    <el-form-item label="任务">
                        {{planItem.cate2}}
                    </el-form-item>
                </el-row>
                <el-row  type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="计划执行时间">
                        {{planItem.shortPlanSDate}} 至  {{planItem.shortPlanEDate}}
                    </el-form-item>                    
                </el-row>
                <el-divider content-position="left" style="margin-top:15px;"><span style="font-size:larger;"></span></el-divider>

                <el-row  type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="结案时间">
                        <!-- <el-date-picker
                            v-model="form.finishTime"
                            type="datetime"
                            value-format="yyyy-MM-dd hh:MM:ss" format="yyyy-MM-dd hh:MM:ss" 
                            placeholder="选择服务时间">
                        </el-date-picker> -->
                        <el-date-picker
                            v-model="form.finishTime"
                            type="datetime"
                            placeholder="选择服务时间">
                        </el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row v-if="planItem.seg=='Renew'" type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="续约结论">
                        <el-select v-model="form.renewResultId" style="width:400px;" clearable placeholder="请选择">
                            <el-option v-for="item in renewList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row v-if="planItem.seg=='Renew' && form.renewResultId=='55'" type="flex" style="margin-top:15px;" align="center">
                    <el-form-item label="不续费原因">
                        <el-input v-model="form.unRenewReason" size="medium" :rows="4" type="textarea"
                                    autocomplete="off" placeholder="" style="width:700px"
                                    ></el-input>                       
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="结案说明">
                        <el-input v-model="form.finishDescript" size="medium" :rows="4" type="textarea"
                                    autocomplete="off" placeholder="" style="width:700px"
                                    ></el-input>     
                    </el-form-item>                   
                </el-row>

                <div  style="display:flex;justify-content:center;margin-top:20px;">
                    <el-button @click="close()">关闭</el-button>
                    <el-button style="margin-left:20px;" type="primary" @click="onSetFinish">保存</el-button>
                </div> 

                <el-divider content-position="center">跟进历史</el-divider>
                <el-timeline :reverse="reverse">
                    <el-timeline-item v-for="(activity, index) in doLog" :key="index" :timestamp="activity.dealDate">
                        <!-- {{activity.dealContent}} -->
                        <p style="margin-left:20px;" v-if="activity.dealContent" v-html="activity.dealContent.replace('\r\n','\n').split('\n').map(item => `<p>${item}</p>`).join('')"></p>
                        <div style="display:flex" v-for="(sample, indexs) in activity.sampleArr" :key="indexs">
                            <el-link type="primary" :href="sample.url" target="_blank">{{sample.name}}</el-link>
                        </div>
                        
                        <!-- <my-upload-file-form-item v-model="activity.sampleArr" label="附件" :limit="10" /> -->
                    </el-timeline-item>
                </el-timeline>

            </el-form>

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {ZC_FinishPlan} from "@/api/zc";
import { getToken } from "@/utils/auth";
import {getSampleArrayFromSever,getSampleLogStrToSever} from "@/utils/tools";

export default {
    name: 'baseform',
    props: ['planItem'],
    components: {
        MyUploadFileFormItem
      },
    computed: {
        ...mapGetters(["renewList","resultList"])
    },
    data() {
        return {
            form:{
                finishTime:'',
                renewResultId:'',
                unRenewReason:'',
                finishDescript:''
            },
            doLog:[],
            reverse: false,
        };
    },

    async mounted() {
        this.doLog=[];
        await this.$store.dispatch('zc/renewList');

        await this.$store.dispatch('zc/resultList',{planId:this.planItem.id}).then(()=>{
            this.resultList.forEach(ele=>{
                var obj={};
                var samples = ele.samples;
                obj=ele;
                obj.sampleArr=getSampleArrayFromSever({samples});
                this.doLog.push(obj);
            })
        });     
       
    },


    methods: {
        close(){
            this.$emit('close');
        },

        async onSetFinish(){
          
            const {finishTime,renewResultId,unRenewReason,finishDescript} = this.form;
            if (!finishTime){
                this.$message.warning('选择结案时间')
                return;
            }

            var dDate = new Date(finishTime+'').toLocaleDateString();
            var h=finishTime.getHours();
            var m=finishTime.getMinutes();
            var s=finishTime.getSeconds();
            if (h<10){
                h='0'+h;
            }
            if (m<10){
                m='0'+m;
            }
            if (s<10){
                s='0'+s;
            }
            dDate = dDate + ' '+h+':'+m+':'+s;

            if (this.planItem.seg=='Renew' && !renewResultId){
                this.$message.warning('请选择续约结论')
                return;
            }
            if (this.planItem.seg=='Renew' && renewResultId=='55' && !unRenewReason){
                this.$message.warning('请填写不续费原因')
                return;
            }
            // var finishTime = dtime;//new Date(dtime).toLocaleDateString();

            await ZC_FinishPlan({planId:this.planItem.id,finishTime:dDate,finishDescript,renewResultId,unRenewReason});
            this.$message.success('保存成功');
            this.$emit("onSetFinishOver");
            // this.onQuery();
            // this.doDialogVisible=false;
        },
    }
};
</script>

<style scoped>
</style>